<div [formGroup]="formGroup" ngxsForm="forms.commentForm">
    <mat-card-header>
      <span mat-card-avatar>
        <mat-icon>comment</mat-icon>
      </span>
      <mat-card-title style='margin-top: 10px;     margin-left: -17px;'>{{modalTitle}}</mat-card-title>
    </mat-card-header>
    <div>
      <br>
      <br>
      <div class="flex-container" fxLayout="row">
          <mat-form-field class="full-width">
            <textarea minlength="3" matInput placeholder="New Tracking Url" formControlName ="comment"></textarea>
          </mat-form-field>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div class="mat-card-actions-container">
      <mat-card-actions>
        <div fxLayout="row">
          <span fxFlex></span>
          <button type="button" mat-raised-button (click)="back()" class="text-upper">Cancel</button>
          <button style="font-size: 10px;
          margin-right: 5px;
          scale: 1;
          color: white;
          border-radius: 0px;
          text-shadow: none;
          box-shadow: none;
          flex: 1 1 100%;
          box-sizing: border-box;
          max-width: 50px;
          cursor: pointer;
          transition: background-color 0.3s;
          box-shadow: none !important;"  mat-raised-button (click)="save()"
            [disabled]="!formGroup.valid" [style.background-color]="formGroup.valid ? ' #bf1e2e' : 'gray'"
            class="text-upper">{{submitTitle}}</button>
        </div>
      </mat-card-actions>
    </div>
  </div>
  